<template>
  <v-container>
    <h2>Ангийн онлайн өрөөнүүд</h2>
    <v-container class="mx-auto" style="width: 80%">
      <v-card
        color="transparent"
        :elevation="0"
        v-for="(school, index) in schools"
        :key="index"
      >
        <v-card-title class="m-0">
          <div class="d-flex justify-content-end">
            <label v-if="canChange">
              <input
                type="checkbox"
                style="transform: scale(1.4)"
                class="mr-2"
                v-model="addRoom"
              />
              <span class="" style="font-weight: normal; font-size: 14pt"
                >Өрөө оруулаx</span
              >
            </label>
          </div>
        </v-card-title>
        <v-card-text>
          <v-row
            v-for="department in school.departments"
            v-bind:key="department.id"
            justify="start"
          >
            <v-card
              flat
              v-for="program in department.programs"
              v-bind:key="program.id"
              @click="_clicked(school, department, program)"
              :title="program.onlineroom"
              class="ma-2"
              width="100"
            >
              <div
                class="v-skeleton-loader theme--light text-primary calllink"
                style=""
              >
                <v-card-text
                  v-if="
                    program.onlineroom == null || program.onlineroom.length == 0
                  "
                >
                  <div class="d-flex align-center">
                    <div
                      class="v-avatar mr-4 primary--text primary lighten-5"
                      style="height: 24px; min-width: 24px; width: 24px"
                    >
                      <i
                        aria-hidden="true"
                        class="
                          v-icon
                          notranslate
                          mdi mdi-account
                          theme--light
                          primary--text primary
                          lighten-5
                        "
                      ></i>
                    </div>
                    <div>
                      <h6 class="card-title mb-1" color="red">
                        <span
                          > <small style="color:red">No room </small></span
                        ><small class=" text-primary font-weight-bold"
                          >({{ department.name
                          }}{{ program.name.toUpperCase() }})</small
                        >
                      </h6>
                    </div>
                  </div>
                </v-card-text>
                <v-card-text v-else>
                  <div class="d-flex align-center">
                    <div
                      class="v-avatar mr-4 primary--text primary lighten-5"
                      style="height: 24px; min-width: 24px; width: 24px"
                    >
                      <img src="assets/img/onlineroom.png" alt="" width="20%" />
                    </div>
                    <div>
                      <h6 class="card-title mb-1" color="red">
                        {{ department.name }}{{ program.name.toUpperCase() }}
                      </h6>
                    </div>
                  </div>
                </v-card-text>
              </div>
            </v-card>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
    <div
      class="modal fade"
      id="onlineRoomModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="proModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="proModalLabel">Бүлэг нэмэх</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="user">
              <div class="form-group">
                <label>Онлайн уулзалтын линк</label>
                <textarea
                  rows="1"
                  v-model.trim="selectedProgram.onlineroom"
                  class="form-control"
                  placeholder="Онлайн уулзалтын линк"
                />
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Цуцлаx
            </button>
            <button
              @click="_saveOnlineRoom"
              type="button"
              class="btn btn-primary btn-user btn-block"
              data-dismiss="modal"
            >
              Xадгалаx
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="loading == true"
      style="position: fixed; z-index: 10000000; top: 45%; left: 45%"
    >
      <div class="spinner-grow text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-secondary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-danger" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-warning" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-info" role="status">
        <span class="sr-only">Loading...</span>
      </div>
      <div class="spinner-grow text-dark" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </v-container>
</template>

<script>
const fb = require("../firebaseConfig.js");
import Vue from "vue";
import { mapState } from "vuex";
import { currentUser } from "../firebaseConfig.js";
import moment from "moment";
export default {
  name: "XOnlineRooms",
  data() {
    return {
      canChange: false,
      addRoom: false,
      schools: [],
      defaultPrograms: ["А", "Б", "В", "Г", "Д", "Е", "Ё"],
      userObject: null,
      selectedProgram: { onlineroom: null },
      selectedDepartment: null,
      selectedSchool: null,
      loading: false,
    };
  },
  computed: {
    ...mapState(["currentUser", "userProfile"]),
  },
  created() {
    this._getData();
  },

  methods: {
    _clicked(school, department, program) {
      this.selectedSchool = school;
      this.selectedDepartment = department;
      this.selectedProgram = program;
      if (this.addRoom && this.canChange) {
        $("#onlineRoomModal").modal("toggle");
      } else {
        console.log(department.name, program.name);
        console.log(program.onlineroom);
        window.open(this.selectedProgram.onlineroom, "_blank");
      }
    },
    _saveOnlineRoom() {
      if (
        this.selectedSchool &&
        this.selectedDepartment &&
        this.selectedProgram
      ) {
        fb.db
          .collection("schools")
          .doc(this.selectedSchool.id)
          .collection("departments")
          .doc(this.selectedDepartment.id)
          .collection("programs")
          .doc(this.selectedProgram.id)
          .update({
            onlineroom: this.selectedProgram.onlineroom,
          });
      }
    },
    async _readPrograms(school, department) {
      department.programs = [];
      fb.db
        .collection(
          "schools/" + school.id + "/departments/" + department.id + "/programs"
        )
        .orderBy("index", "asc")
        .get()
        .then((departments) => {
          departments.forEach((program) => {
            let programData = program.data();
            programData.id = program.id;
            programData.ref = program.ref;
            department.programs.push(programData);
          });
        });
    },
    async _readDepartments(school) {
      console.log(school);
      school.departments = [];
      fb.db
        .collection("schools/" + school.id + "/departments/")
        .where("startYear", "==", school.currentYear)
        .orderBy("index", "asc")
        .get()
        .then((departments) => {
          departments.forEach(async (dep) => {
            let depData = dep.data();
            depData.id = dep.id;
            depData.ref = dep.ref;
            await this._readPrograms(school, depData);
            school.departments.push(depData);
          });
        });
    },
    async _getData() {
      this.loading = true;
      if (
        this.userProfile.role == "sts" ||
        this.userProfile.role == "manager" ||
        this.userProfile.role == "admin"
      ) {
        this.canChange = true;
      } else this.canChange = false;

      console.log(this.userProfile.customer.path);
      console.log(this.userProfile);
      this.userProfile.customer.get().then(async (doc) => {
        doc
          .data()
          .school.get()
          .then(async (schoolDoc) => {
            let aschool = schoolDoc.data();
            aschool.id = schoolDoc.id;
            aschool.ref = schoolDoc.ref;
            this.school = aschool;
            await this._readDepartments(aschool);
            this.schools.push(aschool);
            this.loading = false;
          });
      });

      // console.log(this.userProfile.customer.path)
      // this.userProfile.customer.get().then(async (doc) => {
      //   let data = doc.data();
      //   data.id = doc.id;
      //   data.ref = doc.ref;
      //   if (
      //     this.userProfile.role &&
      //     (this.userProfile.role == "teacher" ||
      //       this.userProfile.role == "manager" )
      //   ) {
      //     console.log(doc);
      //     doc.data()
      //       .school.get()
      //       .then(async (schoolDoc) => {
      //         let school = schoolDoc.data();
      //         school.id = schoolDoc.id;
      //         school.ref = schoolDoc.ref;
      //         await this._readDepartments(school);
      //         this.schools.push(school);
      //       });
      //   }else if(this.userProfile.role &&this.userProfile.role=='admin'|| this.userProfile.role == "sts"){

      //     var schools = await doc.data().schools;
      //     for(var school of schools){
      //       var schoolDoc = await school.get();
      //       let school = schoolDoc.data();
      //       school.id = schoolDoc.id;
      //       school.ref = schoolDoc.ref;
      //       await this._readDepartments(school)
      //       this.schools.push(school);
      //     }

      //   }
      //    this.loading = false
      // });
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).fromNow();
    },
  },
};
</script>